import React from 'react'
import { Box, Typography } from '@mui/material'

const secciones = [
  {
    titulo: '1. Entrar en la aplicacion',
    items: [
      'Escribe tu usuario y contrasena en la pantalla de entrada.',
      'Al entrar veras el menu superior con el nombre de la empresa, Planificador, Ajustes y Guia.',
      'En la parte derecha aparece tu nombre de usuario.',
      'Desde tu usuario puedes abrir el menu para cambiar tu contrasena.',
      'Usa el icono de salida para cerrar la sesion cuando termines.',
    ],
  },
  {
    titulo: '2. Elegir centro de trabajo',
    items: [
      'Cuando estas en el Planificador, junto al nombre de la empresa aparecen los centros disponibles.',
      'Pulsa sobre el centro con el que quieras trabajar.',
      'El centro seleccionado se queda marcado en naranja.',
      'La aplicacion recuerda el ultimo centro usado para que no tengas que seleccionarlo cada vez.',
    ],
  },
  {
    titulo: '3. Entender el planificador',
    items: [
      'Cada fila del tablero es una salida de produccion.',
      'La parte horizontal muestra las horas del dia.',
      'La linea naranja vertical marca la hora actual.',
      'Las tarjetas dentro del tablero son pedidos ya colocados en una salida de produccion.',
      'El color de la tarjeta ayuda a saber si esta pendiente, en curso, completada o retrasada.',
      'Puedes moverte por el tablero usando las barras de desplazamiento.',
    ],
  },
  {
    titulo: '4. Ver otros dias y mas horas',
    items: [
      'Usa el selector de fecha para consultar otro dia.',
      'Puedes avanzar o retroceder de dia con los controles de la pantalla.',
      'Usa los botones de mas y menos horas para ampliar o reducir la vista.',
      'Aunque cambies la vista, las tarjetas mantienen su duracion real.',
    ],
  },
  {
    titulo: '5. Pedidos pendientes',
    items: [
      'Encima del tablero aparece el apartado Pedidos pendientes.',
      'Cada tarjeta muestra el numero de pedido, variedad, confeccion, calibre, cliente y cantidad de palets.',
      'Tambien puedes ver cuantos palets estan planificados, terminados y pendientes.',
      'Usa el buscador para encontrar rapidamente un pedido por numero, linea, variedad, confeccion, calibre o cliente.',
      'Puedes contraer este apartado para ganar espacio en pantalla.',
    ],
  },
  {
    titulo: '6. Planificar un pedido',
    items: [
      'Busca el pedido en el apartado Pedidos pendientes.',
      'Arrastra la tarjeta hasta la salida de produccion donde quieras colocarlo.',
      'Suelta la tarjeta sobre la hora aproximada de inicio.',
      'La planificacion aparecera en el tablero con la duracion que corresponda.',
      'Si el pedido ya tenia parte planificada, solo se moveran los palets que queden pendientes de planificar.',
    ],
  },
  {
    titulo: '7. Mover o quitar una planificacion',
    items: [
      'Para cambiar una planificacion, arrastra su tarjeta dentro del tablero.',
      'Puedes moverla a otra hora o a otra salida de produccion.',
      'Para quitarla del tablero, arrastrala de vuelta al apartado Pedidos pendientes.',
      'La pantalla se actualizara con la nueva posicion cuando se guarde el cambio.',
    ],
  },
  {
    titulo: '8. Dividir una planificacion',
    items: [
      'Pulsa el boton de tijeras de una tarjeta planificada.',
      'Se abrira una ventana con los palets de esa planificacion.',
      'Pulsa sobre los cuadrados para decidir cuantos palets se quedan y cuantos se separan.',
      'Elige la salida de produccion a la que quieres enviar la parte separada.',
      'Confirma la division para crear la nueva planificacion.',
    ],
  },
  {
    titulo: '9. Colores y estados',
    items: [
      'Verde significa completado.',
      'Naranja significa activo o en curso.',
      'Rojo significa retrasado.',
      'Gris significa en espera o pendiente de empezar.',
      'Dentro de algunas tarjetas veras divisiones por palet.',
      'Al pasar el cursor por un palet puedes ver informacion de tiempo cuando este disponible.',
    ],
  },
  {
    titulo: '10. Ver el detalle de un pedido',
    items: [
      'Haz doble click sobre una tarjeta de pedido pendiente o sobre una tarjeta planificada.',
      'Se abrira una ventana con la informacion del pedido.',
      'La informacion esta separada en bloques para facilitar la consulta.',
      'Cuando termines, pulsa Cerrar para volver al planificador.',
    ],
  },
  {
    titulo: '11. Ajustes',
    items: [
      'En Ajustes se gestionan los datos base de la aplicacion.',
      'Segun tus permisos, veras unas opciones u otras.',
      'Usuarios permite crear usuarios, cambiar datos y gestionar accesos.',
      'Roles permite definir que puede hacer cada tipo de usuario.',
      'Almacenes, tipos de maquinas y salidas de produccion sirven para configurar el planificador.',
      'Parametros tiempo sirve para mantener los valores necesarios para calcular la duracion de las planificaciones.',
      'Maestros Business Central muestra datos de referencia como confecciones y variedades.',
    ],
  },
  {
    titulo: '12. Mensajes y avisos',
    items: [
      'Si una accion no se puede completar, aparecera un aviso en pantalla.',
      'Lee el mensaje para saber que dato falta o que accion no se ha podido guardar.',
      'Si no ves pedidos, revisa primero que el centro seleccionado sea el correcto.',
      'Si no ves salidas de produccion, puede que no haya salidas activas para ese centro.',
      'Si una tarjeta cambia ligeramente de posicion al soltarla, la aplicacion la ha colocado en el punto valido mas adecuado.',
    ],
  },
]

export const GuiaUsuario = () => (
  <Box sx={{ width: '100%', px: { xs: 2, md: 4 }, py: { xs: 2, md: 3 }, boxSizing: 'border-box' }}>
    <Box sx={{ maxWidth: 1120, mx: 'auto' }}>
      <Box sx={{ mb: 2.5 }}>
        <Typography sx={{ color: '#172033', fontWeight: 900, fontSize: { xs: '1.4rem', md: '1.9rem' }, lineHeight: 1.15 }}>
          Guia de usuario
        </Typography>
        <Typography sx={{ color: '#64748B', fontSize: '0.95rem', mt: 0.8 }}>
          Ayuda rapida para utilizar Citrus Planner en el trabajo diario.
        </Typography>
      </Box>

      <Box sx={{ display: 'grid', gap: 1.4 }}>
        {secciones.map((seccion) => (
          <Box
            key={seccion.titulo}
            sx={{
              border: '1px solid #DEE6F2',
              borderRadius: '8px',
              backgroundColor: '#FFFFFF',
              overflow: 'hidden',
            }}
          >
            <Box sx={{ px: 1.6, py: 1, borderBottom: '1px solid #E6ECF5', backgroundColor: '#F8FAFC' }}>
              <Typography sx={{ color: '#172033', fontWeight: 900, fontSize: '0.98rem' }}>
                {seccion.titulo}
              </Typography>
            </Box>
            <Box component="ul" sx={{ m: 0, px: 3.2, py: 1.2, color: '#334155' }}>
              {seccion.items.map((item) => (
                <Typography
                  key={item}
                  component="li"
                  sx={{ fontSize: '0.9rem', lineHeight: 1.55, mb: 0.45 }}
                >
                  {item}
                </Typography>
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  </Box>
)
